<div class="participants-toolbar">
  <div class="participant-search">
    <mat-icon>search</mat-icon>
    <input
      type="search"
      [(ngModel)]="searchTerm"
      placeholder="Buscar participante"
      aria-label="Buscar participante"
    />
  </div>

  <div class="sort-toggle" aria-label="Ordenar participantes">
    <button
      type="button"
      [class.active]="sortMode === 'name'"
      (click)="setSortMode('name')"
    >
      Nombre
    </button>
    <button
      type="button"
      [class.active]="sortMode === 'standing'"
      (click)="setSortMode('standing')"
    >
      Clasificación
    </button>
  </div>
</div>

<div class="participants-list">
  @if (filteredUsers.length === 0) {
    <div class="empty-state">
      <mat-icon>group_off</mat-icon>
      <span>Ningún participante</span>
    </div>
  }

  @for (user of filteredUsers; track user._id) {
    <button type="button" class="user-row" (click)="selectUser(user)">
      <span class="user-position">
        @if (getPosition(user); as position) {
          #{{ position }}
        } @else {
          -
        }
      </span>
      <app-avatar [user]="user" class="user-avatar-wrap"></app-avatar>
      <span class="user-copy">
        <span class="user-name">{{ user.name }}</span>
        @if (user.prediction?.label) {
          <span class="user-prediction">
            {{ user.prediction.label }}
            @if (user.prediction.winnerTeam?.flag) {
              <img
                [src]="user.prediction.winnerTeam.flag"
                [alt]="user.prediction.winnerTeam.name"
              />
            }
          </span>
        }
      </span>
    </button>
  }
</div>
